import { render, staticRenderFns } from "./SignUpTabModal.vue?vue&type=template&id=1f6e4f90&scoped=true"
import script from "./SignUpTabModal.vue?vue&type=script&lang=js"
export * from "./SignUpTabModal.vue?vue&type=script&lang=js"
import style0 from "./SignUpTabModal.vue?vue&type=style&index=0&id=1f6e4f90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6e4f90",
  null
  
)

export default component.exports